export default __webpack_public_path__ + "static/media/SR_3.f1e57154.png";